module.exports = __webpack_public_path__ + "media/images/illustrations/confetti-donkey-coins-73e1cac708a1b3cb5ec23b5bd2b78ce0.svg";